import { render, staticRenderFns } from "./weya-pagination.vue?vue&type=template&id=151f91c0&"
import script from "./weya-pagination.vue?vue&type=script&lang=js&"
export * from "./weya-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports